package core.validation.field

import core.validation.validator.Validator

class ListField<T>(
    private vararg val validators: Validator<List<T>>,
) : FieldImpl<List<T>>(
        initialValue = emptyList(),
        validators = validators,
    )
